import React from 'react';
import PropTypes from 'prop-types';
import PriceText from '../atoms/text/Price';

const PriceBlock = (props) => {
  const { className, priceTotal, adultPrice } = props;

  return (
    <div className={`${className} priceBlock`}>
      <div className="priceBlockTop">
        <div className="priceBlockTitle noWrap">大人１名あたり料金</div>
        <div className="priceBlockPrice">
          <PriceText>{adultPrice.toLocaleString()}円</PriceText>
        </div>
      </div>
      <div className="priceBlockBottom">
        <div className="priceBlockTitle">合計料金</div>
        <div className="priceBlockPrice">
          <PriceText priceType="red">{priceTotal.toLocaleString()}円</PriceText>
        </div>
      </div>
    </div>
  );

};

PriceBlock.defaultProps = {
  className: '',
  priceTotal: 0,
  adultPrice: 0,
};

PriceBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  adultPrice: PropTypes.number,
  priceTotal: PropTypes.number,
};

export default PriceBlock;
